var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 0 0-3.28 17.38c-.079-.711-.15-1.804.032-2.581.163-.702 1.055-4.474 1.055-4.474s-.27-.539-.27-1.336c0-1.251.726-2.186 1.629-2.186.768 0 1.139.577 1.139 1.268 0 .773-.492 1.927-.745 2.997-.213.896.448 1.627 1.332 1.627 1.6 0 2.83-1.687 2.83-4.122 0-2.155-1.55-3.662-3.76-3.662-2.56 0-4.064 1.921-4.064 3.906 0 .774.298 1.603.67 2.054.073.09.084.167.062.258-.068.285-.22.896-.25 1.021-.04.164-.13.2-.3.12-1.125-.523-1.828-2.166-1.828-3.487 0-2.838 2.063-5.446 5.947-5.446 3.122 0 5.549 2.225 5.549 5.198 0 3.102-1.956 5.598-4.67 5.598-.913 0-1.77-.474-2.063-1.033 0 0-.452 1.718-.561 2.14-.203.78-.752 1.76-1.12 2.358A9 9 0 1 0 9 0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.51a0aa50.svg";
export { ForwardRef as ReactComponent };